import * as React from 'react';

export function Professionalize() {
  return (
    <section className="verdu-pro">
      <style>{`
        .verdu-pro {
          padding: 72px 24px;
          background: #fafaf7;
        }
        .verdu-pro-inner {
          max-width: 960px;
          margin: 0 auto;
        }
        .verdu-pro h2 {
          font-size: 28px;
          font-weight: 800;
          color: #1a1a1a;
          margin: 0 0 8px;
          text-align: center;
        }
        .verdu-pro .subtitle {
          font-size: 16px;
          color: #666;
          text-align: center;
          margin: 0 0 40px;
        }
        .verdu-pro-cards {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 24px;
        }
        .verdu-pro-card {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          background: #fff;
          border-radius: 12px;
          padding: 18px 20px;
          border: 1px solid #eee;
        }
        .verdu-pro-card .card-icon {
          width: 40px;
          height: 40px;
          border-radius: 10px;
          background: #f0fdf0;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .verdu-pro-card .card-icon i {
          font-size: 18px;
          color: #1EAA25;
        }
        .verdu-pro-card-text h3 {
          font-size: 15px;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0 0 4px;
        }
        .verdu-pro-card-text p {
          font-size: 14px;
          color: #666;
          line-height: 1.5;
          margin: 0;
        }
        .verdu-pro .closing {
          text-align: center;
          font-size: 16px;
          color: #333;
          font-weight: 600;
          margin: 36px 0 0;
        }
        @media (max-width: 768px) {
          .verdu-pro-cards {
            grid-template-columns: 1fr;
            gap: 16px;
          }
          .verdu-pro h2 {
            font-size: 24px;
          }
        }
      `}</style>
      <div className="verdu-pro-inner">
        <h2>Ordená tu negocio</h2>
        <p className="subtitle">Todo lo que necesitás para profesionalizar tu verdulería.</p>

        <div className="verdu-pro-cards">
          <div className="verdu-pro-card">
            <div className="card-icon"><i className="fa fa-credit-card" /></div>
            <div className="verdu-pro-card-text">
              <h3>Crédito y cuenta corriente</h3>
              <p>Accedé a crédito definido y transparente. Sabés cuánto debés, cuándo pagás y planificás mejor tu flujo.</p>
            </div>
          </div>
          <div className="verdu-pro-card">
            <div className="card-icon"><i className="fa fa-chart-simple" /></div>
            <div className="verdu-pro-card-text">
              <h3>Historial de compras</h3>
              <p>Consultá qué compraste, cuándo y a qué precio. Controlá tu reposición con datos reales.</p>
            </div>
          </div>
          <div className="verdu-pro-card">
            <div className="card-icon"><i className="fa fa-tags" /></div>
            <div className="verdu-pro-card-text">
              <h3>Precios según tu volumen</h3>
              <p>Accedé a listas de precios especiales de acuerdo a tu volumen de compra mensual. Cuanto más crecés, mejores condiciones.</p>
            </div>
          </div>
        </div>

        <p className="closing">Una verdulería ordenada crece más rápido.</p>
      </div>
    </section>
  );
}
